var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bulk/Image 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Image 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    d: "M14.6669 9.80076V10.7231C14.6669 10.8762 14.6603 11.0306 14.6469 11.1836C14.4599 13.2897 12.9969 14.6659 10.886 14.6659H5.1145C4.0457 14.6659 3.14389 14.319 2.49593 13.69C2.24209 13.4568 2.02833 13.1827 1.86133 12.8686C2.08177 12.6006 2.32893 12.3072 2.56941 12.0131C2.97689 11.5252 3.37101 11.0433 3.61818 10.7298C3.98558 10.2753 4.95418 9.07891 6.29687 9.64035C6.57075 9.75397 6.81123 9.91438 7.03167 10.0547C7.57275 10.4157 7.79987 10.5226 8.18063 10.3154C8.60148 10.0882 8.87536 9.64035 9.1626 9.17249C9.31624 8.92452 9.46988 8.68457 9.63688 8.46401C10.365 7.51492 11.4872 7.26094 12.4225 7.82237C12.8901 8.10309 13.2909 8.45733 13.6649 8.81758C13.7451 8.89778 13.8253 8.97197 13.8987 9.0455C13.9989 9.14575 14.3329 9.47994 14.6669 9.80076Z",
    fill: "#1C6BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    opacity: 0.4,
    d: "M10.8931 1.33203H5.11488C2.85035 1.33203 1.33398 2.91608 1.33398 5.27477V10.7227C1.33398 11.5441 1.52103 12.2733 1.86171 12.8682C2.08215 12.6002 2.32931 12.3067 2.56979 12.012C2.97727 11.5247 3.37139 11.0428 3.61855 10.7294C3.98595 10.2749 4.95456 9.07849 6.29724 9.63992C6.57113 9.75355 6.81161 9.91396 7.03205 10.0543C7.57313 10.4152 7.80025 10.5222 8.18101 10.3143C8.60185 10.0877 8.87573 9.63992 9.16298 9.17139C9.31662 8.9241 9.47026 8.68415 9.63726 8.46358C10.3654 7.51449 11.4876 7.26051 12.4228 7.82195C12.8904 8.10266 13.2912 8.4569 13.6653 8.81716C13.7455 8.89736 13.8256 8.97155 13.8991 9.04507C13.9993 9.14466 14.3333 9.47885 14.6673 9.80033V5.27477C14.6673 2.91608 13.151 1.33203 10.8931 1.33203Z",
    fill: "#1C6BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    d: "M7.63619 5.86169C7.63619 6.80076 6.85396 7.58275 5.91542 7.58275C4.97754 7.58275 4.19531 6.80076 4.19531 5.86169C4.19531 4.92329 4.97754 4.14062 5.91542 4.14062C6.85396 4.14062 7.63619 4.92329 7.63619 5.86169Z",
    fill: "#1C6BFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.410749888da4f0da43aec1564d9ee7e9.svg";
export { ForwardRef as ReactComponent };